/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorPlugins } from '../../types/EditorPlugins';
import { findInvalidPlugins } from '../findInvalidPlugins/findInvalidPlugins';
import { findUnneededPlugins } from '../findUnneededPlugins/findUnneededPlugins';
import { getPluginByClassName } from '../getPluginByClassName/getPluginByClassName';

export function getPluginsToDeselect( editorPlugins: EditorPlugins, pluginsToDeselect: EditorPlugins ): EditorPlugins {
	const newEditorPlugins = new Set( editorPlugins );
	const deletePlugin = newEditorPlugins.delete.bind( newEditorPlugins );

	const allPluginsToDeselect = pluginsToDeselect.flatMap( mapPluginToIncludeItsForceDeleteRequires );

	allPluginsToDeselect.forEach( deletePlugin );

	findInvalidPlugins( [ ...newEditorPlugins ] )
		.flatMap( mapPluginToIncludeItsForceDeleteRequires )
		.forEach( deletePlugin );

	findUnneededPlugins( [ ...newEditorPlugins ] )
		.flatMap( mapPluginToIncludeItsForceDeleteRequires )
		.forEach( deletePlugin );

	return [ ...newEditorPlugins ];
}

function mapPluginToIncludeItsForceDeleteRequires( pluginItem: EditorPlugins[ number ] ) {
	const { forceDeleteRequires } = getPluginByClassName( pluginItem );

	if ( forceDeleteRequires ) {
		return [ pluginItem, ...forceDeleteRequires ];
	}

	return [ pluginItem ];
}

